api = require('../api.coffee').api
db = require('../libraries/db.coffee').db
store = require('../store/store.js').store

class Session
  constructor: ->
    @authorized = false
    @callbacks = {
      session_started: []
      session_finished: []
      current_user_updated: []
    }

    @startSession(db.get('session-info'))

  startSession: (session_info) ->
    return unless session_info

    moment.tz.setDefault(session_info.timezone)
    @setCurrentUser session_info

    if @current_user.extradata.use_new_ui && window == window.parent
      window.location = "#{process.env.NEW_URL_REEV}/auth/novo-reev?redirect=#{window.location.pathname.slice(1,)}"
      return

    @setHttpHeaders()
    @authorized = true
    @runCallbacks 'session_started', @

  clearAll: ->
    store.dispatch("resetUsers")
    store.dispatch("resetTags")
    store.dispatch("resetTemplateCategory")
    store.dispatch("resetNotifications")
    store.dispatch("resetLostReasons")
    store.dispatch("resetMeetingTypes")

  finishSession: ->
    @clearAll()
    @removeHttpHeaders()
    @deleteSessionInfo()
    @authorized = false
    @current_user = null
    @current_company = null
    
    @runCallbacks 'session_finished', @

  signIn: (session_info) ->
    @saveSessionInfo session_info
    @startSession session_info

  logout: (success, failure) ->
    @finishSession()
    MixpanelCtrl.logout()
    success() if success

  # Callbacks
  addCallback: (hook, callback) ->
    available_hooks = Object.keys @callbacks

    unless hook in available_hooks
      console.error "Unknown hook #{hook}, Available hooks: #{available_hooks.join(', ')}"

    @callbacks[hook].push callback

  runCallbacks: (hook, args = {}) ->
    for callback in @callbacks[hook]
      callback args

  # Helpers
  setCurrentUser: (session_info) ->
    @current_user = new User session_info
    @current_company = @current_user.company

  updateCurrentUser: (session_info) ->
    @signIn session_info
    @runCallbacks 'current_user_updated', @

  currentUserCopy: ->
    return null unless @current_user
    new User @current_user

  setHttpHeaders: ->
    Vue.http.headers.common['X-User-Email'] = @current_user.email
    Vue.http.headers.common['X-User-Token'] = @current_user.authentication_token

  removeHttpHeaders: ->
    delete Vue.http.headers.common['X-User-Email']
    delete Vue.http.headers.common['X-User-Token']

  saveSessionInfo: (session_info) ->
    db.set 'session-info', session_info

  deleteSessionInfo: ->
    db.remove 'session-info'

global.Session = new Session



// WEBPACK FOOTER //
// ./src/libraries/session.coffee